import { validateIso8601Period } from './validateIso8601Period';

/**
 * ISO 8601 DURATION в количество месяцев
 * @example "P5Y" => { years: 5, months: 0, days: 0 }
 */
export const iso8601DurationToYearsMonthsDays = (
  isoDuration?: string,
): { years: number; months: number; days: number } => {
  const isValid = validateIso8601Period(isoDuration);

  if (!isValid) {
    return {
      years: 0,
      months: 0,
      days: 0,
    };
  }

  let years = parseInt(isoDuration.match(/P(\d+)Y/)?.[1] || '0', 10);
  let months = parseInt(isoDuration.match(/(\d+)M/)?.[1] || '0', 10);
  let days = parseInt(isoDuration.match(/(\d+)D/)?.[1] || '0', 10);

  if (days >= 31) {
    months += Math.floor(days / 31);
    days %= 31;
  }

  if (months >= 12) {
    years += Math.floor(months / 12);
    months %= 12;
  }

  return {
    years,
    months,
    days,
  };
};
